import { default as processClassNames } from 'classnames'
import ToggleNav from '../ToggleNav'
import {
  healthPath,
  helloBabyPostPath,
  registryPath,
  registryHomePath,
  storePath,
} from 'lib/urls'
import useCurrentUser from 'shared/hooks/useCurrentUser/useCurrentUser'
import css from '../../global-nav.scss'

interface LoggedInSiteNavSectionProps {
  activeNavItem?: string
  classNames: any
  handleToggleNav: () => void
  trackClick: (eventCta: string) => void
}

const LoggedInSiteNavSection = ({
  activeNavItem,
  classNames,
  handleToggleNav,
  trackClick,
}: LoggedInSiteNavSectionProps) => {
  const [currentUser] = useCurrentUser()

  let helloBabyPost = null
  switch (currentUser?.currentRegistry?.type) {
    case 'birthday':
      helloBabyPost = 'toddler'
      break
    case 'holiday':
      helloBabyPost = 'holiday'
      break
    default:
      helloBabyPost = null
      break
  }
  return (
    <ul className={processClassNames(classNames)}>
      <ToggleNav onClick={handleToggleNav} />
      <li
        className={processClassNames(
          css.fullNavOnly,
          css.navLink,
          css.homeLink,
          activeNavItem === 'Home' && css.homeActive
        )}
      >
        <a href={registryHomePath} onClick={() => trackClick('Home')}>
          Home
        </a>
      </li>
      <li
        className={processClassNames(
          css.fullNavOnly,
          css.navLink,
          css.registryLink,
          activeNavItem === 'Registry' && css.registryActive
        )}
      >
        <a
          href={
            currentUser?.currentRegistry?.urlSlug
              ? registryPath(currentUser?.currentRegistry?.urlSlug)
              : registryHomePath
          }
          onClick={() => trackClick('Registry')}
        >
          Registry
        </a>
      </li>
      <li
        className={processClassNames(
          css.fullNavOnly,
          css.navLink,
          css.storeLink,
          activeNavItem === 'Store' && css.storeActive
        )}
      >
        <a href={storePath} onClick={() => trackClick('Shop')}>
          Shop
        </a>
      </li>
      <li
        className={processClassNames(
          css.fullNavOnly,
          css.navLink,
          css.guidesLink,
          activeNavItem === 'Guides' && css.guidesActive
        )}
      >
        <a
          href={helloBabyPostPath(helloBabyPost)}
          onClick={() => trackClick('Guides')}
        >
          Guides
        </a>
      </li>
      <li className={processClassNames(css.fullNavOnly, css.navLink)}>
        <a
          href={healthPath}
          onClick={() => trackClick('Health')}
          target="_blank"
        >
          Health
        </a>
      </li>
    </ul>
  )
}

export default LoggedInSiteNavSection
